import endpoints from "api/endpoints";

export default ({ id, successCallback }) => ({
  url: endpoints.getAssignTicketUrl(id),
  queryKey: endpoints.getAssignTicketUrl(),
  meta: {
    authToken: true,
    successCallback,
  },
  force: true,
  options: {
    headers: {
      Accept: "application/json",
    },
    method: "PUT",
  },
});